export default "__VITE_ASSET__DD9O44wx__"